import React, { useEffect, useState } from "react";
import Input from "./Input";
import axios from 'axios'
import { addressFields } from '../addressFields'

const AddressSearch = ({ errors, errorMessage, value: searchTerm, setValue: setSearchTerm, setLockAddressManualFields, setAddressManualFill, addressManualFill,
    setStreetNumber, setStreetName, setSuburb, setState, setPostcode, onLoadingChange = () => {}
}) => {
    // const [searchTerm, setSearchTerm] = useState('')
    const [searchOptions, setSearchOptions] = useState([])
    const [showSearchOptions, setShowSearchOptions] = useState(false)
    const [addressId, setAddressId] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        onLoadingChange(loading);
    }, [loading, onLoadingChange]);

    useEffect(() => {
        if (searchTerm) {
            const handler = setTimeout(() => {
                callAPI()
            }, 1000)

            return () => {
                clearTimeout(handler)
            }
        }
    }, [searchTerm])

    const callAPI = async () => {
        setLoading(true)
        await axios.post(`https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/searchAddress`, {
            searchTerm
        }).then(res => {
            setLoading(false)
            console.log(res.data)
            if (res.data.data.length > 0) {
                setSearchOptions(res.data.data.filter(r => r.uniqueID !== 'UseAddressAsEntered' && r.uniqueID !== 'UseAddressAsEntered_NoValue'))
                setShowSearchOptions(true)
            }
        }).catch(e => {
            setLoading(false)
            setSearchOptions([])
            setShowSearchOptions(false)
            setAddressManualFill(true)
        })
    }


    useEffect(() => {
        if (addressId) {
            callAddressDetailAPI()
        }
    }, [addressId])

    const callAddressDetailAPI = async () => {
        setLoading(true)
        await axios.post(`https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/getAddressDetail`, {
            searchTerm, addressId
        }).then(res => {
            setLoading(false)

            if (res.data.data.status === 'Success') {

                const fields = addressFields(res.data.data.address || {})
                setAddressManualFill(true)
                setStreetNumber(fields.streetNumber)
                setStreetName(fields.streetName)
                setSuburb(fields.suburb)
                setState({ label: fields.state, value: fields.state })
                setPostcode(fields.postcode)
                setLockAddressManualFields(fields.canLock)

            } else {
                setAddressManualFill(true)
            }
        }).catch(e => {
            setLoading(false)

            setAddressManualFill(true)
        })
    }

    return (<div style={{ position: 'relative' }}>
        {!addressManualFill && <Input type={'text'} errorMessage={errors.includes('address') && errors.length === 1 && errorMessage} errors={errors} name={'address'} value={searchTerm} setValue={setSearchTerm} label={'Address'} />}
        {!addressManualFill && showSearchOptions && !searchOptions.find(r => r.label === searchTerm) && <div style={{ position: 'absolute', zIndex: 10, background: 'white', width: '100%', border: '1px solid #DCDCDC' }}>
            {searchOptions.map(r => <div key={r.label} onClick={() => { setSearchTerm(r.label); setAddressId(r.uniqueID); setShowSearchOptions(false); }} style={{ borderBottom: '1px solid #DCDCDC', padding: '5px' }}>{r.label}</div>
            )}
        </div>}
        {loading && <label>Loading...</label>}
        {searchTerm && !addressManualFill && !loading && <label>Unable to find address? <span style={{ textDecorationLine: 'underline' }} onClick={() => { setAddressManualFill(true); setAddressId(''); setSearchTerm('') }}> Fill manually.</span></label>}
    </div>)
}

export default AddressSearch
